import { BASE_URL } from '../../config'

export default async (url, formData, tokenCIF, cb) => {
    console.log("masuk ke upload");
    
	try {
        //initial and set Form Data
        // let formData = new FormData();
        // formData.append(name, file);

        let res = await fetch(`${BASE_URL}${url}`, {
            method : 'POST',
            credentials: 'include',
            body : formData,
            headers : { 
                // 'X-Client-ID' : ClientID
                'Authorization' : 'Bearer ' + tokenCIF
            }
        });
        
    let hasil = await res.json();
    console.log("upload === ", {res, hasil});
    
		if (res.status === 200) {
			cb(hasil.result, null)
		} else {
			cb(null, hasil.status.message)
		}
	} catch (err) {
		cb(null, err.message)
	}
}